module.exports = __webpack_public_path__ + "static/media/anchor_rod_twin_thimble_eye.3bca6e3a.webp";